module.exports = __webpack_public_path__ + "static/la-barclays-d9e1e8edfd6fa88d2acb98182dbd6584.jpg";